export default "__VITE_ASSET__Dto2QFCW__"